import {
  SET_CLOSE_INTERVENTION_FORM_VALID,
  SET_CLOSE_INTERVENTION_FORM_INTERVENTION
} from '../mutation-types'

const state = () => ({
  valid: true,
  intervention: {}
})

const actions = {
}

const mutations = {
  [SET_CLOSE_INTERVENTION_FORM_VALID] (state, value) {
    state.valid = value
  },
  [SET_CLOSE_INTERVENTION_FORM_INTERVENTION] (state, intervention) {
    state.intervention = intervention
  }
}

export default {
  state: state(),
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/closeIntervention.js